import React from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function MechanismSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 bg-gray-50 overflow-hidden" data-id="element-263">
      <Container data-id="element-264">
        <div className="text-center mb-16" data-id="element-265">
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-4" data-id="element-266">
            How It Works{' '}
            <span className="text-blue-600" data-id="element-267">(Simple. Brutal. Effective.)</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-268">
            No complex machinery. No invasive surgery. Just simple mechanics.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-269">
          <div className="order-2 lg:order-1 relative" data-id="element-270">
            <div className="absolute inset-0 bg-blue-100 rounded-full filter blur-3xl opacity-30 transform scale-90" data-id="element-271"></div>
            <img src="https://cdn.magicpatterns.com/uploads/ckEK2fDVMho2aEzwy1jUxB/imgi_30_1746975295-SnoreStop™_(1).png" alt="SnoreStop Mechanism" className="w-full max-w-md mx-auto drop-shadow-2xl relative z-10 transform hover:scale-105 transition-transform duration-500" data-id="element-272" />
          </div>

          <div className="order-1 lg:order-2 space-y-8" data-id="element-273">
            <div className="space-y-6" data-id="element-274">
              {[{
              id: '01',
              title: 'Gently holds your jaw forward',
              desc: 'Keeps your airway open naturally so air flows freely.'
            }, {
              id: '02',
              title: 'Reduces throat vibration',
              desc: 'Stops the tissue collapse that causes loud snoring sounds.'
            }, {
              id: '03',
              title: 'Restores silent breathing patterns',
              desc: 'All night long. So you and your partner finally sleep.'
            }].map((step, index) => <div key={index} className="flex gap-6 p-6 bg-white rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-275">
                  <div className="flex-shrink-0 w-14 h-14 rounded-xl bg-blue-900 text-white flex items-center justify-center font-bold text-2xl shadow-lg shadow-blue-900/20" data-id="element-276">
                    {step.id}
                  </div>
                  <div data-id="element-277">
                    <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-278">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed font-medium" data-id="element-279">
                      {step.desc}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {/* Mini Steps - Simple to Use */}
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-gray-100" data-id="element-280">
          <h3 className="text-2xl md:text-3xl font-bold text-center mb-10" data-id="element-281">
            Simple to Use
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center relative" data-id="element-282">
            {/* Connecting line for desktop */}
            <div className="hidden md:block absolute top-12 left-1/6 right-1/6 h-0.5 bg-gray-100 -z-10" data-id="element-283"></div>

            {[{
            title: 'Dip in warm water',
            icon: '💧'
          }, {
            title: 'Bite down for custom mold',
            icon: '🦷'
          }, {
            title: 'Sleep peacefully',
            icon: '😴'
          }].map((step, i) => <div key={i} className="flex flex-col items-center" data-id="element-284">
                <div className="w-24 h-24 bg-blue-50 rounded-full flex items-center justify-center text-4xl mb-6 border-4 border-white shadow-lg" data-id="element-285">
                  {step.icon}
                </div>
                <h4 className="text-xl font-bold text-gray-900" data-id="element-286">
                  {step.title}
                </h4>
              </div>)}
          </div>

          <div className="mt-12 text-center" data-id="element-287">
            <Button onClick={scrollToPricing} size="lg" className="shadow-lg shadow-blue-900/20" data-id="element-288">
              Get SnoreStop™ Tonight
              <ArrowRight className="ml-2 w-5 h-5" data-id="element-289" />
            </Button>
          </div>
        </div>
      </Container>
    </section>;
}